import { BRAND_LIST } from 'typings'
import * as Typings from '../typings'

const IndiaLocale: Typings.LocaleType = {
  REGION: Typings.RegionGroupNames.SOUTH_ASIA,
  CODE: 'in',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'India',
  SHORT_NAME: 'IN',

  DISPLAY_NAME: 'India (English)',
  DISPLAY_COUNTRY: 'India',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 20.5937,
    INITIAL_LONGITUDE: 78.9629,
    INITIAL_ZOOM: 4,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/in/en/',

  MAP_URL: 'https://www.uniqlo.com/in/shop/',
  // MAP_MOBILE_URL: '',

  TERMS_OF_USE_URL:
    'https://faq-in.uniqlo.com/articles/en_US/FAQ/UQIN-Terms-of-Use/',
  PRIVACY_POLICY_URL:
    'https://faq-in.uniqlo.com/articles/en_US/FAQ/UQIN-Privacy-Policy/',

  CONTACT_US_URL: 'https://faq-in.uniqlo.com/',

  // https://stackoverflow.com/questions/33865525/indian-pincode-validation-regex-only-six-digits-shouldnt-start-with-0
  POSTCODE_FORMAT: /^[1-9][0-9]{5}$/g,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  AM_FORMAT: ' AM',
  PM_FORMAT: ' PM',

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
  CMS_ENABLED: {
    [BRAND_LIST.UQ]: true,
  },
}

export default IndiaLocale
